export default __webpack_public_path__ + "static/media/rubber.cc5b7765.ogg";